import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import { useQuery } from '@apollo/client'

import Pictures, { OPERATION_PICTURES } from './CompleteDetailView/modales/Pictures'

const EquipmentThumbnails = ({ uuid }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [pictureIndex, setPictureIndex] = useState(0)
  const { data } = useQuery(OPERATION_PICTURES, {
    variables: { uuid },
    skip: !uuid
  })
  const pictures = data?.pictures ?? []

  if (!pictures.length) return null

  const handleOpenPicture = index => {
    setPictureIndex(index)
    setOpen(true)
  }

  const handleClosePictures = () => setOpen(false)

  return (
    <>
      <Box mt={2}>
        <Typography variant="h1Card" sx={{ mb: 1 }}>
          {t('supervision.hardware.detail.photos')}
        </Typography>
        <Stack direction="row" gap={1} flexWrap="wrap">
          {pictures.map((picture, index) => (
            <Box
              key={picture.url}
              component="button"
              type="button"
              aria-label={`${t('supervision.hardware.detail.photos')} ${index + 1}`}
              onClick={() => handleOpenPicture(index)}
              sx={{
                width: 88,
                height: 88,
                p: 0,
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                overflow: 'hidden',
                backgroundColor: '#F6F7F8',
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#2570EB'
                }
              }}>
              <Box
                component="img"
                src={picture.url}
                alt={`${t('supervision.hardware.detail.photos')} ${index + 1}`}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
      <Pictures open={open} onClose={handleClosePictures} uuid={uuid} initialIndex={pictureIndex} />
    </>
  )
}

export default EquipmentThumbnails
